export default "__VITE_ASSET__60dea4e8__"